module.exports = __webpack_public_path__ + "static/media/16.71341054.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/16.JPG
// module id = 458
// module chunks = 0